import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M41.877 19.76 38.117 16l-16 16 16 16 3.76-3.76L29.664 32z" }));
export {
  a as default
};
